import React from 'react'
import NumberInput from './NumberInput'
import styles from './s.module.css'
import styles2 from './DesignFlow.module.css'

class DNmanual extends React.Component {
  constructor (props) {
    super(props)
    this.handleSelect = this.handleSelect.bind(this)
  }

  handleSelect (dataObj) {
    this.props.onChange(dataObj.id)
  }

  render () {
    return (
      <div className={styles.dimItemContainer}>
        <label>Vnitřní průměr ID [mm] </label>
        <NumberInput value={this.props.value} className={styles2.designFlowInput}
          onChange={this.props.onChange} />
      </div>
    )
  }
}

// DNmanual.propTypes = {
//   value: PropTypes.number,
//   onChange: PropTypes.func
// }

export default DNmanual
